import "./Modal.css";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import baseUrl from "../../url/baseUrl";

// Modal khi search sản phẩm
const SearchProductModal = (props) => {
  const [searchResult, setSearchResult] = useState([]);
  const [error, setError] = useState(null);

  // Tạo hàm loại bỏ dấu tiếng Việt
  //normalize("NFD") chuyển ký tự về dạng unicode tổ hợp (gồm 2 thành phần là chữ cơ bản và dấu)
  // các dấu nằm trong khoảng \u0300 -> \u036f nên loại bỏ bằng replace thành dấu ""
  const removeDiacritics = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  useEffect(() => {
    const fetchSearchData = async () => {
      try {
        const response = await fetch(baseUrl + "/all-products");

        if (response.status === 404) {
          throw new Error("Sản phẩm không có trên server!");
        }

        if (response.status !== 200) {
          throw new Error("Có lỗi sảy ra với server! ");
        }

        const productItem = await response.json();

        const searchData = productItem.filter((prod) => {
          // Loại bỏ dấu tiếng việt ở searchValue
          const normalizedSearchValue = removeDiacritics(
            props.searchValue.toLowerCase()
          );
          // Loại bỏ dấu tiếng việt ở tên sản phẩm
          const normalizedProductName = removeDiacritics(
            prod.name.toLowerCase()
          );

          return normalizedProductName.includes(normalizedSearchValue);
        });

        setSearchResult(searchData);
        setError(null);
      } catch (err) {
        setError(err.message);
      }
    };
    fetchSearchData();
  }, [props.searchValue]);

  return (
    <div className="modal-overlay-search">
      <div className="modal-content-search rounded">
        <p className="text-info fw-bold text-uppercase">Kết quả tìm kiếm</p>
        {error && <p className="text-center text-primary fw-bold">{error}</p>}
        {searchResult.length !== 0 ? (
          searchResult.map((item, i) => (
            <Link
              className="text-decoration-none"
              to={`/products/${item._id}`}
              target="_blank"
              key={i}
            >
              <div className="d-flex align-items-center mb-3 pb-3 gap-2 border-bottom">
                <img
                  style={{ width: "60px" }}
                  src={item.img1}
                  alt={item.name}
                />
                <p className="text-primary fw-bold">{item.name}</p>
              </div>
            </Link>
          ))
        ) : (
          <p className="text-danger fw-bold">Không tìm thấy sản phẩm</p>
        )}
      </div>
    </div>
  );
};

export default SearchProductModal;
